<template>
  <section>
    <div
      id="header"
      class="container"
      style="border-bottom: 1px solid rgba(222, 222, 222, 0.57)"
    >
      <nav
        id="navbar"
        class="navbar navbar-expand-xl navbar-light"
        style="
          font-color: #0082ba;
          font-size: 12px;
          max-width: 1490px;
          margin: auto;
        "
      >
        <span>
          <a href="https://amcredit.com">
            <img
              :src="require('../../assets/imgs/American Credit_logo_TM_a.png')"
              :srcset="
                require('../../assets/imgs/American-Credit-logo-TM-320w.png') +
                ' 320w, ' +
                require('../../assets/imgs/American-Credit-logo-TM-640w.png') +
                ' 640w, ' +
                require('../../assets/imgs/American-Credit-logo-TM-960w.png') +
                ' 960w'
              "
              class="img-fluid logo"
              alt="American Credit Logo"
              width="240"
              height="62"
            />
          </a>
        </span>

        <div class="row flex-nowrap ml-auto mr-3 d-none d-md-flex d-xl-none">
          <div class="container contact-card mr-1">
            <div class="row align-items-center flex-nowrap">
              <div class="col-auto pl-0">
                <img
                  src="../../assets/imgs/lei-small.png"
                  alt="Lei Photo"
                  class="rounded-circle"
                  style="width: 50px"
                />
              </div>
              <div class="col">
                <div class="row mb-1">
                  <div class="col-1 pl-0 pr-3"></div>
                  <div class="col pl-0 consultant-name">Call Amcredit</div>
                </div>
                <div class="row flex-nowrap consultant-phone">
                  <div class="col-1 pl-0 pr-3">
                    <span class="phone-icon fa fa-phone"></span>
                  </div>
                  <div class="col pl-0 text-nowrap">
                    Sales:
                    <a href="tel:8559040188" class="consultant-phone_number"
                      >855-904-0188</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="container contact-card" v-if="!isIndustryPage">
            <div class="row align-items-center flex-nowrap">
              <div class="col-auto pl-0">
                <img
                  src="../../assets/imgs/lei-contact.jpeg"
                  alt="Corey Photo"
                  class="rounded-circle"
                  style="width: 50px"
                />
              </div>
              <div class="col">
                <div class="row mb-1">
                  <div class="col-1 pl-0 pr-3"></div>
                  <div class="col pl-0 consultant-name">Call Lei</div>
                </div>
                <div class="row flex-nowrap consultant-phone">
                  <div class="col-1 pl-0 pr-3">
                    <span class="phone-icon fa fa-phone"></span>
                  </div>
                  <div class="col pl-0 text-nowrap">
                    Service:
                    <a href="tel:8667921393" class="consultant-phone_number"
                      >650-885-8055</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarsDefault"
          aria-controls="navbarsDefault"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse my-3 my-xl-0" id="navbarsDefault">
          <ul class="navbar-nav h6 desktop-nav">
            <div class="btn-group align-items-center main-item">
              <a
                class="nav-item px-2 pt-2 nav-link text-xl-center text-xxl-left"
                aria-haspopup="true"
                style="
                  font-family: Helvetica;
                  font-weight: 600;
                  cursor: pointer;
                "
                href="https://amcredit.com/equipment-loan"
                >Asset-based Loans</a
              >
              <span class="sr-only">Toggle Dropdown</span>
              <div class="dropdown-menu">
                <a class="dropdown-item nav-link" href="https://amcredit.com/equipment-loan"
                  >Equipment Loans</a
                >
                <a class="dropdown-item nav-link" href="https://amcredit.com/invoice-factoring"
                  >Invoice/AR Factoring</a
                >
                <a class="dropdown-item nav-link" href="https://amcredit.com/vendor-financing">Vendor Financing</a>
              </div>
            </div>

            <div class="btn-group align-items-center main-item">
              <a
                class="nav-item px-2 pt-2 nav-link"
                aria-haspopup="true"
                aria-expanded="false"
                style="
                  font-family: Helvetica;
                  font-weight: 600;
                  cursor: pointer;
                "
                href="https://amcredit.com/industries"
                >Industries</a
              >
              <span class="sr-only">Toggle Dropdown</span>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/commercial-truck-financing"
                  >Trucking</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/loans-for-contractors"
                  >Contractors</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/commercial-construction-loans"
                  >Construction</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/manufacturing-financing"
                  >Manufacturing</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/excavator-financing"
                  >Excavating</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/loans-for-restaurants"
                  >Restaurants</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/loans-for-landscapers"
                  >Landscaping</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/transportation-business-loans"
                  >Transportation</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/commercial-vehicle-loans"
                  >Commercial Vehicles</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/loans-for-farmers"
                  >Farming</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/commercial-real-estate-loans"
                  >Commercial Real Estate</a
                >
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/industries/working-capital-financing"
                  >Working Capital</a
                >
              </div>
            </div>

            <div class="btn-group align-items-center main-item">
              <a
                class="nav-item px-2 pt-2 nav-link"
                aria-haspopup="true"
                aria-expanded="false"
                style="
                  font-family: Helvetica;
                  font-weight: 600;
                  cursor: pointer;
                "
                href="https://amcredit.com/blog"
                >Resources</a
              >
              <span class="sr-only">Toggle Dropdown</span>
              <div class="dropdown-menu">
                <a class="dropdown-item nav-link" href="https://amcredit.com/loan-calculator"
                  >Loan Calculator</a
                >
                <a class="dropdown-item nav-link" href="https://amcredit.com/roi-calculator"
                  >ROI Calculator</a
                >
                <a class="dropdown-item nav-link" href="https://amcredit.com/faq">FAQs</a>
                <a
                  class="dropdown-item nav-link"
                  href="https://amcredit.com/blog"
                  >Blog</a
                >
              </div>
            </div>

            <div class="btn-group align-items-center main-item">
              <a
                class="nav-item px-2 pt-2 nav-link"
                aria-haspopup="true"
                aria-expanded="false"
                style="
                  font-family: Helvetica;
                  font-weight: 600;
                  cursor: pointer;
                "
                href="https://amcredit.com/about-us"
                >Company</a
              >
              <span class="sr-only">Toggle Dropdown</span>
              <div class="dropdown-menu">
                <a class="dropdown-item nav-link" href="https://amcredit.com/partners">Partners</a>
                <a class="dropdown-item nav-link" href="https://amcredit.com/brokers">Brokers</a>
                <a class="dropdown-item nav-link" href="https://amcredit.com/careers">Careers</a>
                <a class="dropdown-item nav-link" href="https://amcredit.com/about-us">About Us</a>
                <a class="dropdown-item nav-link" href="https://amcredit.com/team">Team</a>
              </div>
            </div>
          </ul>
          <div
            style="margin: 0 0 0 auto"
            class="navbar-nav justify-content-end self-align-right align-items-right h6 mt-3 mt-lg-0"
          >
            <div
              class="container contact-card ml-0 mr-lg-1 ml-lg-2 mb-3 mb-lg-0 d-md-none d-xl-block"
            >
              <div class="row align-items-center flex-nowrap">
                <div class="col-auto pl-2 pl-lg-0">
                  <img
                    src="../../assets/imgs/lei-small.png"
                    alt="Lei Photo"
                    class="rounded-circle"
                    style="width: 50px"
                  />
                </div>
                <div class="col">
                  <div class="row mb-1">
                    <div class="col-1 pl-0 pr-3"></div>
                    <div class="col pl-0 consultant-name">Call Amcredit</div>
                  </div>
                  <div class="row flex-nowrap consultant-phone">
                    <div class="col-1 pl-0 pr-3">
                      <span class="phone-icon fa fa-phone"></span>
                    </div>
                    <div class="col pl-0 text-nowrap">
                      Sales:
                      <a href="tel:8559040188" class="consultant-phone_number"
                        >855-904-0188</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-group align-items-center">
              <template v-if="isLogin">
                <a
                  class="nav-item px-2 nav-link text-nowrap"
                  @click="confirmLogout"
                  >Log Out</a
                >
              </template>
              <template v-else>
                <a
                  class="nav-item px-2 text-nowrap"
                  href="/login"
                  onClick="window.location='/login'"
                  style="
                    font-family: Helvetica;
                    color: #5456ff;
                    font-size: 16px;
                    font-weight: 700;
                  "
                  >Sign In</a
                >
              </template>

              <template v-if="isLogin">
                <div>
                  <li class="px-2">
                    <router-link
                      v-if="employer.customerType == '1'"
                      to="/personalCenter"
                      class="text-danger text-nowrap"
                    >
                      {{ employer.name | ellipsis }}
                    </router-link>
                    <router-link
                      v-if="employer.customerType == '8'"
                      to="/brokerCenter"
                      class="text-danger text-nowrap"
                    >
                      {{ employer.name | ellipsis }}
                    </router-link>
                    <!--<a style="cursor: pointer;background:#2B66A0; font-style:italic; color:#e06d21!important;transform: skew(0);padding:10px 15px;border-radius: 8px;" class="header__logout" @click.prev="logout">LOG OUT</a>-->
                  </li>
                </div>
              </template>

              <template v-if="isLogin"></template>
              <template v-else>
                <router-link to="/get-start" tag="button" class="cta ml-3"
                  >Apply Now</router-link
                >
              </template>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";

export default {
  data() {
    return {
      employer: {
        name: "",
      },
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
  },
  computed: {
    ...mapGetters({
      companyInfo: types.GET_COMPANY_INFO,
      isLogin: types.IS_LOGIN,
      userInfo: types.GET_USER,
      products: types.GET_HOT_PRODUCTS,
      //				getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    isIndustryPage: function () {
      return this.$route.path.includes("/industries");
    },
  },
  methods: {
    ...mapActions({
      userLogout: types.USER_LOGOUT,
      getEnableCreditQuotaSwitch: types.GET_ENABLE_CREDIT_QUOTA_SWITCH,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA,
    }),
    logout() {
      this.userLogout({
        router: this.$router,
      });
    },
    goToIndex() {
      this.$router.push({
        path: "/",
      });
    },
    gotoApply(item) {
      api
        .get("/mobile/item/loanItemFrontApply/mgxyIsCanApply.ht", {
          tokenId: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push(`/applyLoan/${item.productId}/sbl`);
          } else if (res.data.code == 1) {
            this.$alert(res.data.msg);
          }
        });
    },

    confirmLogout() {
      this.userLogout({
        router: this.$router,
      });
    },

    handleScroll() {
      //    alert("scrolled");

      var nav = document.getElementById("navbar");

      if (
        document.body.scrollTop > 0 ||
        document.documentElement.scrollTop > 0
      ) {
        nav.classList.add("whitebg");
      } else {
        nav.classList.remove("whitebg");
      }

      var header = document.getElementById("header");
      //  alert(header);
      (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) &&
        header.classList.add("has-scrolled");

      //  $headerApply.addClass("green"),
      //   $menuMobileApply.addClass("show-apply"),
      //  $innerHamburger.addClass("hamburger-scroll")
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    // æ£€æµ‹æ˜¯å�¦å�¯ç”¨é¢�åº¦
    // this.getEnableCreditQuotaSwitch()

    /*
			 			document.querySelector('.header1').style.height = document.querySelector('.header1').children[0].clientHeight + 'px';


						window.onresize = function() {
							console.log(1);
							document.querySelector('.header1').style.height = document.querySelector('.header1').children[0].clientHeight +
								'px';
						}


						window.onscroll = function() {

							if (document.documentElement.scrollTop > 500) {
								document.querySelector('.header1').style.position = 'fixed';
								document.querySelector('.header1').style.boxShadow = '0 0 10px rgba(0, 0, 0, .5)';
							} else {
								document.querySelector('.header1').style.position = 'relative';
								document.querySelector('.header1').style.boxShadow = 'none';
							}

						}
			*/

    if (this.userInfo.token) {
      var _this = this;
      this.getPersonalInitData({
        token: this.userInfo.token,
        customerId: this.userInfo.crmCustomerId,
      })
        .then((res) => {
          console.log(res);
          if (Number(res.data.code) === 0) {
            const data = res.data.result;
            this.employer = {
              name: data.employer.name,
              customerType: data.customerType,
            };
            // this.customerType = data.customerType;
            // console.log(this.customerType);
          } else {
            console.log(res.data);
          }
        })
        .catch(function (err) {
          // Instead, this happens:
          console.log("It failed!", err);
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../assets/css/index.css";
/* @import "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"; */

/*  Adjust Navbar Box settings      */
.boldfont {
  font-weight: bold;
}

#header {
  max-width: 1520px;
}
#header .navbar-nav {
  margin-left: 0;
}

@media (min-width: 1200px) {
  #header .navbar-nav {
    margin-left: 20px;
  }
}

.consultant-name {
  color: #696969;
  font-size: 12px;
}

.consultant-phone .fa-phone,
.consultant-phone_number {
  color: #5456ff;
  font-weight: 600;
}

.desktop-nav .main-item > a {
  font-size: 17px;
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .desktop-nav .main-item > a {
    font-size: 14px;
  }
}

.tc-header,
.navbar.notresp .navbar-inner {
  background-color: #ffff11;
}

.amc {
  color: blue;
  font-weight: 800 !important;
}

.logo {
  display: block;
  width: 13vw;
  min-width: 14em;
  max-width: 250px;
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 8%;
}

.header1 {
  position: relative;
  width: 100%;
  top: 0;
  /*height:97px;*/
  height: 100%;
  z-index: 999;
  background: #fff;
}

.header1 .container {
  background: #fff;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.getStarted {
  margin-top: 3px;
  display: inline-block;
  padding: 0px 20px;
  min-width: 180px;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 35px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  border: none;
  border-radius: 24px;
  -webkit-border-radius: 24px;
  -moz-border-radius: 24px;
  -ms-border-radius: 24px;
  -o-border-radius: 24px;
  background: rgba(224, 110, 33, 1);
  background: -moz-linear-gradient(
    left,
    rgba(224, 110, 33, 1) 0%,
    rgba(243, 190, 0, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 110, 33, 1)),
    color-stop(100%, rgba(243, 190, 0, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 110, 33, 1) 0%,
    rgba(243, 190, 0, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 110, 33, 1) 0%,
    rgba(243, 190, 0, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 110, 33, 1) 0%,
    rgba(243, 190, 0, 1) 100%
  );
  background: linear-gradient(to right, #6ec800 0%, #6ec888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e06e21',
  endColorstr='#f3be00', GradientType=1);
  box-shadow: none;
  box-sizing: border-box;
  outline: none;
  cursor: pointer;
}

.dropdown-item {
  font-weight: 600;
}
.consultant-name,
.consultant-phone {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// Header.vue?2b38f9ec